import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_stmt_account_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  statement_type: fromDatatype.VarcharDatatypeInterface;
  printable_format_guid: fromDatatype.GuidDataFieldInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  soa_settings_json: fromDatatype.JsonDatatypeInterface;
  recipient_emails: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_stmt_account_template_hdr_RowClass
  implements bl_fi_stmt_account_template_hdr_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  statement_type: fromDatatype.VarcharDatatypeInterface;
  printable_format_guid: fromDatatype.GuidDataFieldInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  soa_settings_json: fromDatatype.JsonDatatypeInterface;
  recipient_emails: fromDatatype.JsonDatatypeInterface;
}